<template>
	<div class="c-body">
		<div class="c-body__title">
			<h2>
				<span>DataURI</span>
				<button @click="toggleHelp" :class="{'-active': showHelp}">
					<c-icon :name="'question-circle'"></c-icon>
				</button>
			</h2>
		</div>
		<div class="c-help">
			<div class="c-help__inner">
				<div class="e-section">
					<p>
						ペーストされたデータや、ドロップされたファイルからDataURIを生成します。<br>
						サイズ上限は2MBです。（上限はオプションで制限解除できます）
					</p>
					<label class="e-label">
						<input type="checkbox" v-model="options.disableLimit">
						<span class="label">サイズ制限を解除する</span>
					</label>
				</div>
			</div>
		</div>
		<div class="c-body__inner">
			<div class="e-section">
				<div class="c-datauri-droparea" @drop="onDrop">
					<div class="c-datauri-droparea__text">
						このエリアにファイルをドロップするか、データをペーストしてください
					</div>
				</div>
			</div>
			<hr class="e-hr">
			<div class="e-section">
				<div class="c-datauri-result">
					<ul class="c-datauri-result__list">
						<transition-group name="slide-in">
							<li class="c-datauri-result__item" v-for="(r, index) in results" :key="r.key">
								<div class="c-datauri-result__preview" :style="r.style">
									<div class="c-datauri-result__preview-text" v-if="r.text">{{r.text}}</div>
								</div>
								<div class="c-datauri-result__content">
									<button class="c-datauri-result__button-remove" @click="remove(r.key)">
										<c-icon :name="'cross'"></c-icon>
									</button>
									<dl class="c-datauri-result__props">
										<dt>type</dt>
										<dd>{{r.type}}</dd>
										<dt>size</dt>
										<dd>{{r.size | formatNumber}}</dd>
									</dl>
									<textarea class="e-input-text -full -invert" readonly v-model="r.data"></textarea>
								</div>
							</li>
						</transition-group>
						<!--
						<li class="c-datauri-result__item">
							<div class="c-datauri-result__preview" style="background-image:url(//placehold.it/600x400)">
								<div class="c-datauri-result__preview-text">
									Lorem ipsum dolor sit amet, consectetur adipisicing elit. Possimus voluptates, ipsa eligendi! Ullam deleniti ipsum, cupiditate omnis velit nesciunt quia inventore, nostrum cumque fuga voluptas facilis vero temporibus, esse, magnam.
								</div>
							</div>
							<div class="c-datauri-result__content">
								<button class="c-datauri-result__button-remove">
									<c-icon :name="'cross'"></c-icon>
								</button>
								<dl class="c-datauri-result__props">
									<dt>type</dt>
									<dd>text/plain</dd>
									<dt>size</dt>
									<dd>123456</dd>
								</dl>
								<textarea class="e-input-text -full -invert" readonly>hogehogehoge</textarea>
							</div>
						</li>
						-->
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>


import mCommon from "../mixins/common";

export default {
	mixins: [
		mCommon
	],

	data (){
		return {
			options: {
				maxsize: 2000000,
				disableLimit: false
			},
			results: []
		}
	},

	created (){
		document.addEventListener("paste", this.onPaste);
		document.addEventListener("drop", $.preventDefault);
		document.addEventListener("dragover", $.preventDefault);
	},

	methods: {

		onPaste (e){
			this.loadFiles(e.clipboardData.items);
		},

		onDrop (e){
			this.loadFiles(e.dataTransfer.items);
		},

		loadFiles (files){
			Array.from(files).forEach((item) => {
				this.load(item).then((data) => {
					this.results.unshift(data);
				});
			});
		},

		load (item){
			return new Promise((resolve, reject) => {
				var type = item.type,
					data,
					size,
					reader;

				// text の場合は btoa
				if(/^text\//.test(type)){
					item.getAsString((str) => {
						data = `data:${type};` + btoa(unescape(encodeURIComponent(str)));
						size = data.length;

						if(size > this.options.maxsize && !this.options.disableLimit){
							return alert("ちょっとサイズが大きすぎますね");
						}

						resolve({
							key: [type, size, $.now()].join("-"),
							text: str,
							type,
							data,
							size
						});
					});
					return;
				}

				reader = new FileReader();
				reader.addEventListener("load", () => {
					data = reader.result;
					size = data.length;

					if(size > this.options.maxsize && !this.options.disableLimit){
						return alert("ちょっとサイズが大きすぎますね");
					}

					resolve({
						key: [type, size, $.now()].join("-")	,
						image: true,
						type,
						data,
						size,
						style: `background-image:url(${data})`
					});
				});
				reader.readAsDataURL(item.getAsFile());
			});
		},

		remove (key){
			this.results = this.results.filter((r) => {
				return r.key !== key;
			});
		}

	}
}
	
</script>


// WEBPACK FOOTER //
// datauri.vue?bac75d34